var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},".st0{fill:#aea198}"),React.createElement("g",{"id":"XMLID_2_","key":1},React.createElement("path",{"id":"XMLID_6_","className":"st0","d":"M354.2 216c0-38.2-13-70.7-40-97.7s-59.6-40-97.7-40-70.7 13-97.7 40-40 59.6-40 97.7 13 70.7 40 97.7 59.6 40 97.7 40 70.7-13 97.7-40c26-27.9 40-60.5 40-97.7zm157.3 256c0 10.2-3.7 19.5-12.1 27.9a36.7 36.7 0 01-27.9 12.1 35.2 35.2 0 01-27.9-12.1L339.3 393.8A208.4 208.4 0 01216.4 432c-29.8 0-57.7-5.6-83.8-16.8-27-11.2-50.3-27-68.9-46.5s-34.4-42.8-46.5-68.9a218.7 218.7 0 01.1-167.6c11.2-27 27-50.3 46.5-68.9s42.8-34.4 68.9-46.5a216.4 216.4 0 01167.5 0 201 201 0 0168.9 46.5 255.3 255.3 0 0146.5 68.9 216.6 216.6 0 01-21.4 206.7L499.4 444a35.5 35.5 0 0112.1 28z"}))]);
}

SearchIcon.defaultProps = {"version":"1.1","x":"0","y":"0","viewBox":"0 0 512 512","xmlSpace":"preserve"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
